import React from 'react';
import DocumentTitle from 'react-document-title';
import StartupFold from '../../components/StartupFold';
import StartupSubFold from '../../components/StartupSubFold';
import StartupCards from '../../components/StartupCards';
import StartupTimeline from '../../components/StartupTimeline';
import StartupFooter from '../../components/StartupFooter';
import StartupFaq from '../../components/StartupFaq';
import StartupDesigners from '../../components/StartupDesigners';
import styles from './styles.scss';

function Startup ({
  showModal,
  anchorTo,
  submitSuccess
}) {

  return (
    <DocumentTitle title='0-to-startup'>
      <div className={styles.main}>
        <StartupFold />
        <div className={styles.slant}>
          <hr className="slant mtb100" />
        </div>
        <StartupSubFold />
        <div className="mt100" />
        <hr />
        <StartupCards />
        <div className="mt100" />
        <hr />
        <StartupTimeline />
        <hr />
        <StartupDesigners />
        <hr />
        <div className="container-fluid main-container">
          <div className="col-md-10 col-md-offset-1 col-sm-12">
            <StartupFaq />
          </div>
        </div>
        <StartupFooter />
      </div>
    </DocumentTitle>
  );
}

export default Startup;



// WEBPACK FOOTER //
// ./src/pages/Startup/index.js